import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import FileTypeIcon from '../../../components/FileTypeIcon';
import { iconType } from '../../../utils/iconUtil';
var MessageDocument = function MessageDocument(_ref) {
  var title = _ref.title,
    fileName = _ref.fileName,
    subtitle = _ref.subtitle,
    children = _ref.children,
    onClick = _ref.onClick;
  var iconProps = iconType(fileName);
  return /*#__PURE__*/React.createElement("div", {
    className: "MessageDocument",
    role: "button",
    onClick: onClick
  }, !children && /*#__PURE__*/React.createElement("div", {
    className: "MessageDocument__iconContainer"
  }, /*#__PURE__*/React.createElement(FileTypeIcon, _extends({
    width: "48"
  }, iconProps)), title && /*#__PURE__*/React.createElement("div", {
    className: "MessageDocument__fileName"
  }, fileName)), /*#__PURE__*/React.createElement("div", {
    className: "MessageDocument__text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "MessageDocument__title"
  }, title || fileName), subtitle && /*#__PURE__*/React.createElement("p", {
    className: "MessageDocument__subtitle"
  }, subtitle)));
};
MessageDocument.propTypes = {
  title: PropTypes.node,
  fileName: PropTypes.string,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.any
};
export default MessageDocument;
//# sourceMappingURL=MessageDocument.js.map
